import React, { Component } from 'react';
import { BrowserRouter as Router, Route, withRouter, Switch } from "react-router";

class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0);
      }
    }
  
    render() {
      return this.props.children;
    }
  }
  
  export default ScrollToTop;
  // export default withRouter(ScrollToTop);